/*! Copyright 2025 Lane Crawford, All Rights Reserved. */

/**
 *
 * [ module ]
 * infoPage -> general
 *
 */

( function( LC, $ ) {

	"use strict";

	new lcmodule2( "infoPage.general", function( exports, _this ) {

		var ex = exports;

		// set up some objects for grouping functions
		ex.commonClass = {
			active: "is-active",
			hideForMobile: "hide-for-mb-only",
			rotate: "go",
			fadeOut: "opc-0"
		};
		ex.slideAnimationDuration = 330;
		ex.activeState = {};
		ex.infoContentObj = {};
		ex.track = {};

		_this.scrollAnimation;

		/**
		 * set up the default variable
		 */
		ex.setup = function() {

			_this.namespace = ".infoPage";

			_this.$infoContent = $( ".info-help" );
			_this.$contentListTempl = $( "#tmpl-contentList" );
			_this.$contentDescriptionTempl = $( "#tmpl-contentDesc" );
			_this.$canonical = $( "link[ rel='canonical' ]" );

		};

		ex.init = function() {

			// initialisation code

			_this.pageName = _this.$infoContent.data( "page" );
			_this.infoTargeter = _this.$infoContent.data( "type" );
			_this.pageDomain = location.protocol + "//" + location.hostname;
			_this.pageUrlBase = "/info/help/" + _this.pageName + "/";
			_this.animationDelay = 600;

			_this.historyState = LC.location.pathname;

			LC.infoContent.general.load( _this.pageName ).done( function() {

				LC.pubsub.trigger( "contentReady" + _this.namespace );

			} );

		};

		/**
		 * compose url by page name, sectionId, subsectionId, contentId.
		 * if the composed url is different to current url, replace the current
		 * browser history
		 *
		 * - the debounce is for delay action for set history to eliminate quick history update / false click
		 * - the slideDownNicely / slideUpNicely will be draggy, when running setHistory in the same time, so
		 *   it set delay 500ms
		 *
		 * @param  {string} sectionId    | the required section id
		 * @param  {string} subsectionId | the required subsection id
		 * @param  {String} contentId    | the required content id
		 */
		ex.setHistory = _.debounce( function( sectionId, subsectionId, contentId ) {

			var base = "/info/help/" + _this.pageName + "/",
				param = sectionId + "/",
				url,
				canonicalURL;

			if ( subsectionId !== undefined ) {
				param = param + subsectionId + "/";
				canonicalURL = param;
			}

			if ( contentId  !== undefined ) {
				param = param + contentId + "/";
			}

			url = base + param;
			canonicalURL = base + canonicalURL;

			 // only update history and fire pageview if it
			 // is a different url/path to previously.
			if ( _this.historyState !== url ) {

				// update the current URL, but
				// do not add a new history state. This is
				// so the user doesn't have a ton of history to
				// go through to get to previous page.
				history.replaceState( null, null, url );

				ex.updateCanonical( canonicalURL );

				// update previous history state
				_this.historyState = url;

			}

		}, 500 );

		/**
		 * update the link calue of meta canonical url
		 * @param  {string} url   | url that contain sectionId / subsectionId data but omit contentId.
		 *                          e.g: "info/help/help-and-info/online/my-order/"
		 */
		ex.updateCanonical = function( url ) {

			var canonicalURL = _this.pageDomain + url;

			_this.$canonical.attr( "href", canonicalURL);

		};

		/**
		 * get the desired content, render the new content html
		 * @param  {array / string} contents     | requested content, if content is array, it will generate html list,
		 *                                         otherwise will generate diret content
		 * @param  {string} sectionId            | sectionId that contents belong to
		 * @param  {string} subsectionId         | subsectionId that contents belong to
		 * @param  {string} contentId            | contentId that contents belong to
		 */
		_this.generateContentHTML = function( contents, sectionId, subsectionId, contentId ) {

			var html;

			// generate html code
			if ( _.isArray( contents ) ) {

				html = ex.generateContentlist( contents, sectionId, subsectionId );

			} else {

				html = ex.generateContentDescription( contents );

			}

			// set content to ".info-content__detail" column
			LC.pubsub.trigger( "updateContent" + _this.namespace, html );

			if ( subsectionId ) {
				// ask subsection module to append content html to ".info-content__menu" column which is for mobile view
				LC.pubsub.trigger( "updateSubsectionChild" +
						_this.namespace, [ subsectionId, html ] );
			} else {
				// ask section module to append content html to ".info-content__menu" column which is for mobile view
				LC.pubsub.trigger( "updateSectionChild" +
						_this.namespace, [ sectionId, html ] );
			}

		};

		/**
		 * render the contents array into html list by template
		 * @param  {array} contents  | array of contents
		 * @return {string}          | html lists of contents
		 */
		ex.generateContentlist = function( contents, sectionId, subsectionId ) {

			var linkBase = _this.pageUrlBase + sectionId + "/",
				html,
				urlLink,
				template;

			if ( subsectionId !== undefined ) {
				linkBase = linkBase + subsectionId + "/";
			}

			$.each( contents, function( index, content ) {

				urlLink = linkBase + content.contentId + "/";

				_.extend( content, {
					sectionId: sectionId,
					subsectionId: subsectionId,
					urlLink: urlLink,
					animationTimeStamp: index * ( _this.animationDelay / contents.length )
				} );

			} );

			template = Handlebars.compile( _this.$contentListTempl.html() );
			html = template( {
				contents: contents
			} );

			return html;

		};

		/**
		 * render the direct contents in html by template
		 * @param  {string} content    | html code content
		 * @return {string}            | html code which generate from template
		 */
		ex.generateContentDescription = function( content ) {

			var html = "",
				template;

			template = Handlebars.compile( _this.$contentDescriptionTempl.html() );

			html = template( {
				description: content
			} );

			return html;

		};

		ex.scrollToViewport = function( $target ) {

			var rect,
				lowerScreen;

			if ( $target.length ) {

				if ( _this.scrollAnimation ) {
					clearTimeout( _this.scrollAnimation );
				}

				// prevent page jumping back up to top on refresh
				history.scrollRestoration = "manual";

				// set timeout for making sure that the position of expanded section / subsection / content is in the right position
				_this.scrollAnimation = setTimeout( function() {

					rect = $target.get( 0 ).getBoundingClientRect();
					lowerScreen = $( window ).height() * 0.75;

					if ( rect.y < 0 || rect.y > lowerScreen ) {

						$( "html, body" ).animate({
							scrollTop: $target.offset().top
						}, 500);

					}

				}, 300 );

			}

		};

		ex.events = function() {

			$(window).on("beforeunload", function() {
				// allow page to restore scroll position
				history.scrollRestoration = "auto";
			});

		};

		ex.subscribe = function() {

			LC.pubsub.on( "setHistory.section.infoPage " +
							"setHistory.subsection.infoPage " +
							"setHistory.content.infoPage", function( e, sectionId, subsectionId, contentId ) {

				ex.setHistory( sectionId, subsectionId, contentId );

			} );

			LC.pubsub.on( "return.infoContent", function( e, contentObj ) {

				var contents = contentObj.contents,
					sectionId = contentObj.sectionId,
					subsectionId = contentObj.subsectionId,
					contentId = contentObj.contentId;

				_this.generateContentHTML( contents, sectionId, subsectionId, contentId );

			} );

			LC.pubsub.on( "finishExpand.section.infoPage " +
				"finishExpand.subsection.infoPage " +
				"finishExpand.content.infoPage", function( e, target ) {

				if ( Foundation.MediaQuery.is( "mb only" ) ) {
					ex.scrollToViewport( $( target ) );
				}

			});

		};

		return exports;

	});

}( window.LC = window.LC || {}, jQuery ));

/**
 *
 * [ module ]
 * infoPage -> section
 *
 */

( function( LC, $ ) {

	"use strict";

	new lcmodule2( "infoPage.section", function( exports, _this ) {

		var ex = exports;

		// set up some objects for grouping functions
		_this.mobile = {};
		ex.track = {};

		/**
		 * set up the default variable
		 */
		ex.setup = function() {

			_this.namespace = ".section.infoPage";

			_this.$menuColumn = $( ".info-menu" );
			_this.$sectionLink = $( ".info-section__link" );
			_this.$sectionChildContentTempl = $( "#tmpl-sectionChildContent" );

		};

		ex.init = function() {

			// initialisation code
			_this.commonClass = LC.infoPage.general.commonClass;
			_this.slideAnimationDuration = LC.infoPage.general.slideAnimationDuration;

			_this.clickEvent = "touchend" + _this.namespace + " " +
								"click" + _this.namespace;

			ex.initActiveSectionObj();

		};

		/**
		 * init the activeObj by getting
		 * 	- active ".info-section__item"
		 * 	- active ".info-section__child"
		 * 	- active ".info-section__link-icon"
		 * 	- active section id
		 */
		ex.initActiveSectionObj = function() {

			var $activeSectionItem = $( ".info-section__item.is-active" ),
				$activeSectionChild = $activeSectionItem.find( ".info-section__child" ),
				$activeSectionLink = $activeSectionItem.find( ".info-section__link" ),
				$activeSectionIcon = $activeSectionLink.find( ".info-section__link-icon" ),
				sectionId = $activeSectionItem.find( ".info-section__link" ).data( "section" );

			_this.activeObj = {

				$item:          $activeSectionItem,
				$child:         $activeSectionChild,
				$icon:          $activeSectionIcon,
				sectionId:      sectionId

			};

		};

		/**
		 * get data about the user clicked section item link
		 *
		 * @param  {jQuery} $target     | jQuery object to section link
		 * @return {object} targetObj   | object contain following info
		 *                          	   - jQuery object of the clicked secion item
		 *                          	   - jQuery object of the clicked secion child
		 *                          	   - jQuery object of the clicked secion icon
		 *                          	   - section id
		 */
		_this.getTargetSectionDetail = function( $targetItem ) {

			var $targetChild = $targetItem.find( ".info-section__child" ),
				$link = $targetItem.find( ".info-section__link" ),
				$targetIcon = $link.find( ".info-section__link-icon" ),
				targetId = $link.data( "section" ),
				targetObj;

			targetObj = {
				$item: $targetItem,
				$child: $targetChild,
				$icon: $targetIcon,
				sectionId: targetId
			};

			return targetObj;

		};

		/**
		 * handling section link clicking by 2 different cases
		 * 	- when clicking active section link in "mobile site", call "_this.mobile.toggleActiveSection()"
		 * 	- when clicking non-active section link, call "_this.changeSection()"
		 *
		 * @param  {jQuery}   | $target jQuery object to section link
		 */
		_this.clickSection = _.throttle( function( $target ) {

			var $targetSectionItem = $target.closest( ".info-section__item" ),
				targetObj = _this.getTargetSectionDetail( $targetSectionItem ),
				isTargetActive = targetObj.$item.hasClass( _this.commonClass.active );

			if ( isTargetActive ) {

				if ( Foundation.MediaQuery.is( "mb only" ) ) {

					_this.mobile.toggleActiveSection();

				}

			} else {

				_this.changeSection( targetObj );

			}

		}, 500, {
			leading: true,
			trailing: false
		} );

		/**
		 * handling clicking non active section link
		 * 	1. deactivate / collapse exising section
		 * 	2. activate / expand clicked section
		 *
		 * @param  {object} targetObj   | include data:
		 *     - $item
		 *     - $child
		 *     - $icon
		 *     - sectionId
		 */
		_this.changeSection = function( targetObj ) {

			var $item = _this.activeObj.$item,
				$child = _this.activeObj.$child;

			_this.deactivateSection( function() {
				if ( $child.hasClass( "direct-content" ) ) {
					$child.remove();
				}
			} );
			// remove "activeClass" for the current active section
			$item.removeClass( _this.commonClass.active );

			// add "activeClass" for the clicked ".info-section__item"
			targetObj.$item.addClass( _this.commonClass.active );

			// cached active jquery object
			_this.activeObj = targetObj;

			// expand the target ".info-section__child", and add rotate class to active section link icon
			if ( targetObj.$child.length ) {

				_this.activateSection( function() {
					if (Foundation.MediaQuery.is("mb only")) {
						LC.pubsub.trigger("finishExpand" + _this.namespace, _this.activeObj.$item);
					}
				});

			}

			// update the new section id to activeState object in LC.infoPage.general and update the browser history
			LC.pubsub.trigger( "setHistory" + _this.namespace, targetObj.sectionId );

			// as the section change, the active subsection and active content need to be updated
			LC.pubsub.trigger( "change" + _this.namespace, [ targetObj.$item, targetObj.sectionId ] );

		};

		/**
		 * action for deactivate current section
		 *  1. call "_this.collapseSection()" for collapse the current section child
		 *  2. remove the class "hide-in-mobile"
		 *
		 * "hide-in-mobile" is mainly for mobile, because mobile can collapse current
		 * section child by clicking current section link ( not select another section)
		 */
		_this.deactivateSection = function( callback ) {

			var $child = _this.activeObj.$child,
				$icon = _this.activeObj.$icon;

			$child.css( "display", "block" );
			_this.collapseSection( callback );

			$icon.removeClass( _this.commonClass.rotate );
			$child.removeClass( _this.commonClass.hideForMobile );

		};

		/**
		 * action for activate clicked section
		 *  1. call "_this.expandSection()" for expand the clicked section child
		 *  2. add "rotateClass" to the clicked section icon
		 *
		 * section icon only display in mobile view
		 *
		 */
		_this.activateSection = function( callback ) {

			var $child = _this.activeObj.$child,
				$icon = _this.activeObj.$icon;

			_this.expandSection( $child, callback );
			$icon.addClass( _this.commonClass.rotate );

		};

		/**
		 * collapse an element
		 *
		 * @param  {Function} callback   | code after slide up animation
		 */
		_this.collapseSection = function( callback ) {

			_this.activeObj.$child.slideUp( _this.slideAnimationDuration, callback );

		};

		/**
		 * expand an element
		 *
		 * @param  {Function} callback   | code after slide down animation
		 */
		_this.expandSection = function( $target, callback ) {

			$target.slideDown( _this.slideAnimationDuration, callback );

		};

		/**
		 * action for clicking active section link
		 * 	- if clicked section item has "hideInMobileClass" which mean the sction is active
		 * 	  but collapse in mobile
		 * 	  	- remove the "hideInMobileClass", so the section child should be visible
		 * 	  	- add css display: none, to keep the section child invisible. Therefore
		 * 	  	  the expand section animation can work right
		 * 	  	- call "_this.activateSection()" for the expand animation
		 *  - else run "_this.deactivateSection" for collapse the clicked section
		 */
		_this.mobile.toggleActiveSection = function() {

			var isTargetHideInMobile = _this.activeObj.$child.hasClass( _this.commonClass.hideForMobile ),
				$child = _this.activeObj.$child;

			if ( isTargetHideInMobile ) {

				$child.removeClass( _this.commonClass.hideForMobile );
				$child.css( "display", "none" );

				_this.activateSection();

			} else {

				_this.deactivateSection( function() {

					$child.addClass( _this.commonClass.hideForMobile );
					$child.css( "display", "block" );

				} );

			}

		};

		/**
		 * append section direct content to below info-section__link-title
		 * @param  {String} sectionId    section id of current active section
		 * @param  {String} html         content html
		 */
		_this.mobile.appendSectionContent = function( sectionId, html ) {

			var $child,
				template,
				sectionChildHtml;

			// create section child and append param html
			template = Handlebars.compile( _this.$sectionChildContentTempl.html() );
			sectionChildHtml = template( {
				content: html
			} );

			// append section child to current active ".info-section__item"
			_this.activeObj.$item.append( sectionChildHtml );

			// find the newly added ".info-section__child" and update it to "$child" in activeObj
			$child = _this.activeObj.$item.find( ".info-section__child" );
			$child.css( "display", "none" );

			// cached the $child to activeObj
			_this.activeObj.$child = $child;

			// expand the newly added active ".info-section__child", and add rotate class to active section link icon
			// trigger "finishExpand.section.infoPage" after expand animation
			_this.activateSection( function() {
				LC.pubsub.trigger( "finishExpand" + _this.namespace, _this.activeObj.$item );
			} );

			// rebind the content link in LC.infoPage.general
			LC.pubsub.trigger( "finishAppendContent"  + _this.namespace, _this.activeObj.$item );

		};

		ex.sectionEvents = function() {

			_this.$sectionLink
				.off( _this.namespace )
				.checkmove()
				.on( _this.clickEvent, function( e ) {

					e.preventDefault();

					if ( !$( this ).data( "touchmoved" ) ) {

						_this.clickSection( $( this ) );

					}

				});

		};

		ex.events = function() {

		};

		ex.subscribe = function() {

			LC.pubsub.on( "contentReady.infoPage", function() {

				ex.sectionEvents();

			} );

			LC.pubsub.on( "updateSectionChild.infoPage", function( e, sectionId, html ) {

				// after retrieve the desired info content, update active section direct content
				_this.mobile.appendSectionContent( sectionId, html );

			} );

		};

		return exports;

	});

}( window.LC = window.LC || {}, jQuery ));

/**
 *
 * [ module ]
 * infoPage -> subsection
 *
 */

( function( LC, $ ) {

	"use strict";

	new lcmodule2( "infoPage.subsection", function( exports, _this ) {

		var ex = exports;

		// set up some objects for grouping functions
		_this.mobile = {};
		ex.track = {};

		ex.setup = function() {

			_this.namespace = ".subsection.infoPage";

			_this.$menuColumn = $( ".info-help__menu" );
			_this.$subsectionLink = $( ".info-subsection__link" );
			_this.$subsectionChildTempl = $( "#tmpl-subsectionChild" );

		};

		ex.init = function() {

			// initialisation code
			_this.commonClass = LC.infoPage.general.commonClass;
			_this.slideAnimationDuration = LC.infoPage.general.slideAnimationDuration;

			_this.clickEvent = "touchend" + _this.namespace + " " +
								"click" + _this.namespace;

			ex.initActiveSubsectionObj();

		};

		/**
		 * init the activeObj by getting
		 * 	- active ".info-subsection__item"
		 * 	- active ".info-subsection__child"
		 * 	- active ".info-subsection__bullet"
		 * 	- active ".info-bullet__plus"
		 * 	- active section id
		 * 	- active subsection id
		 */
		ex.initActiveSubsectionObj = function() {

			var $activeSubsectionItem = $( ".info-subsection__item.is-active" ),
				$activeSubsectionChild = $activeSubsectionItem.find( ".info-subsection__child" ),
				$activeSubsectionBullet = $activeSubsectionItem.find( ".info-subsection__bullet" ),
				$activeSubsectionBulletPlus = $activeSubsectionBullet.find( ".info-bullet__plus" ),
				sectionId = $activeSubsectionItem.find( ".info-subsection__link" ).data( "section" ),
				subsectionId = $activeSubsectionItem.find( ".info-subsection__link" ).data( "subsection" );

			_this.activeObj = {

				$item:          $activeSubsectionItem,
				$child:         $activeSubsectionChild,
				$bullet:        $activeSubsectionBullet,
				$bulletPlus:    $activeSubsectionBulletPlus,
				sectionId:      sectionId,
				subsectionId:   subsectionId

			};

		};

		/**
		 * get data about the user clicked section item link
		 *
		 * @param  {jQuery} $target     | jQuery object to section link
		 * @return {object} targetObj   | object contain following info
		 *                                 - jQuery object of the clicked subsecion item
		 *                                 - jQuery object of the clicked subsecion child
		 *                                 - jQuery object of the clicked subsecion bullet
		 *                                 - jQuery object of the clicked subsecion plus icon in bullet
		 *                                 - section id
		 *                                 - subsection id
		 */
		_this.getTargetSubsectionDetail = function( $targetItem ) {

			var $targetChild = $targetItem.find( ".info-subsection__child" ) || "",
				$targetBullet = $targetItem.find( ".info-subsection__bullet" ),
				$targetBulletPlus = $targetBullet.find( ".info-bullet__plus" ),
				sectionId = $targetItem.find( ".info-subsection__link" ).data( "section" ),
				subsectionId = $targetItem.find( ".info-subsection__link" ).data( "subsection" ),
				targetObj;

			targetObj = {
				$item: $targetItem,
				$child: $targetChild,
				$bullet: $targetBullet,
				$bulletPlus: $targetBulletPlus,
				sectionId: sectionId,
				subsectionId: subsectionId
			};

			return targetObj;

		};

		/**
		 * handling subection link clicking by 2 different cases
		 * 	- when clicking active subsection link in "mobile site", call "_this.mobile.toggleActiveSubsection()"
		 * 	- when clicking non-active subsection link, call "_this.changeSubsection()"
		 *
		 * @param  {jQuery}     $target | jQuery object to subsection link
		 */
		_this.clickSubsection = _.throttle( function( $target ) {

			var $targetSubsectionItem = $target.closest( ".info-subsection__item" ),
				targetObj = _this.getTargetSubsectionDetail( $targetSubsectionItem ),
				isTargetActive = targetObj.$item.hasClass( _this.commonClass.active );

			if ( isTargetActive ) {

				if ( Foundation.MediaQuery.is( "mb only" ) ) {

					_this.mobile.toggleActiveSubsection();

				}

			} else {

				_this.changeSubsection( targetObj );

			}

		}, 500, {
			leading: true,
			trailing: false
		} );

		/**
		 * handling clicking non active subsection link
		 * 	1. deactivate / collapse exising subsection
		 * 	2. activate / expand clicked subsection
		 *
		 * @param  {object} targetObj | include data:
		 *     - $item
		 *     - $child
		 *     - $bullet
		 *     - $bulletPlus
		 *     - sectionId
		 *     - subsectionId
		 */
		_this.changeSubsection = function( targetObj ) {

			var $item = _this.activeObj.$item,
				$child = _this.activeObj.$child,
				targetSectionId = targetObj.sectionId,
				targetSubsectionId = targetObj.subsectionId;

			_this.deactivateSubsection( function() {
				$child.remove();
			} );

			// remove "activeClass" and "hideInMobileClass" for the current active section
			$item.removeClass( _this.commonClass.active );
			$item.removeClass( _this.commonClass.hideForMobile );

			// add activeClass for the clicked section
			targetObj.$item.addClass( _this.commonClass.active );

			// cached active jquery object
			_this.activeObj = targetObj;

			// update the new subsection id to activeState object in LC.infoPage.general and update the browser history
			LC.pubsub.trigger( "setHistory" + _this.namespace, [ targetSectionId, targetSubsectionId ] );
			// call "LC.infoContent.general" for retrieve the desired content by section id, subsection id
			LC.pubsub.trigger( "infoContent.retrieve", [ targetSectionId, targetSubsectionId ] );

		};

		/**
		 * action for deactivate current subsection
		 *  1. if in mobile view, call "_this.collapseSection()" for collapse the current
		 *     subection child. Mobile view will show the subsection child right below the section.
		 *     Tablet view subsection child will show in "info-content__detail" column
		 *  2. remove the "rotateClass" for subsection bullet ( in mobile view )
		 *  3. remove the "fadeOutClass" for subsection bullet plus icon ( in mobile view )
		 *
		 * "hide-in-mobile" is mainly for mobile, because mobile can collapse current
		 * section child by clicking current section link ( not select another section)
		 */
		_this.deactivateSubsection = function( callback ) {

			var $child = _this.activeObj.$child,
				$bullet = _this.activeObj.$bullet,
				$bulletPlus = _this.activeObj.$bulletPlus;

			if ( Foundation.MediaQuery.is( "mb only" ) ) {

				_this.mobile.collapseSubsection( $child, callback );

			} else {

				$child.css( "display", "none" );
				callback();

			}

			$bullet.removeClass( _this.commonClass.rotate );
			$bulletPlus.removeClass( _this.commonClass.fadeOut );

		};

		/**
		 * action for activate clicked subsection
		 *  1. call "_this.mobile.expandSection()" for expand the clicked subsection child while in mobile view
		 *  2. add "rotateClass" to the clicked subsection bullet
		 *  3. add "fadeOutClass" to the clicked subsection bullet plus icon
		 */
		_this.activateSubsection = function( callback ) {

			var $child = _this.activeObj.$child,
				$bullet = _this.activeObj.$bullet,
				$bulletPlus = _this.activeObj.$bulletPlus;

			_this.mobile.expandSubsection( $child, callback );

			$bullet.addClass( _this.commonClass.rotate );
			$bulletPlus.addClass( _this.commonClass.fadeOut );

		};

		/**
		 * when section change, need to:
		 *  - remove the original active subsection related active class
		 *  - remove the original active subsection child
		 *  - get new default active subsection item and it's related data
		 *  - update activeObj
		 */
		_this.refreshDefaultSubsection = function( $targetSectionItem, sectionId ) {

			var targetObj,
				$targetSubsectionItem,
				targetSubsectionId;

			/**
			 *  1. remove the "activeClass" for original subsection item
			 *  2. remove the "hideInMobileClass" for original subsection item ( in mobile view )
			 */
			_this.activeObj.$item.removeClass( _this.commonClass.active );
			_this.activeObj.$item.removeClass( _this.commonClass.hideForMobile );
			_this.activeObj.$bullet.removeClass( _this.commonClass.rotate );
			_this.activeObj.$bulletPlus.removeClass( _this.commonClass.fadeOut );
			_this.activeObj.$child.remove();

			// get the new subsection item
			$targetSubsectionItem = $targetSectionItem.find( ".info-subsection__item" ).first();

			if ( $targetSubsectionItem ) {

				// get the new subsection item related data
				targetObj = _this.getTargetSubsectionDetail( $targetSubsectionItem );

				// add the "activeClass" for new subsection item and show the subsection child
				targetObj.$item.addClass( _this.commonClass.active );
				targetObj.$bullet.addClass( _this.commonClass.rotate );
				targetObj.$bulletPlus.addClass( _this.commonClass.fadeOut );
				targetObj.$child.css( "display", "block" );

				targetSubsectionId = targetObj.subsectionId;

				// replace the activeObj with targetObj
				_this.activeObj = targetObj;

			}

			// update the new section id to activeState object in LC.infoPage.general and update the browser history
			LC.pubsub.trigger( "setHistory" + _this.namespace, [ sectionId, targetSubsectionId ]);
			// get the content by  section Id and subsectionId
			LC.pubsub.trigger( "infoContent.retrieve", [ sectionId, targetSubsectionId ] );

		};

		/**
		 * action for clicking active subsection link
		 * 	- if clicked subsection item has "hideInMobileClass" which mean the subsction is active
		 * 	  but collapse in mobile
		 * 	  	- remove the "hideInMobileClass", so the section child should be visible
		 * 	  	- call "_this.activateSubsection()" for the expand animation
		 * 	- else call "_this.deactivateSubsection()" for collapse the subsection
		 */
		_this.mobile.toggleActiveSubsection = function() {

			var $child = _this.activeObj.$child,
				isHideInMobile = $child.hasClass( _this.commonClass.hideForMobile );

			if ( isHideInMobile ) {

				$child.removeClass( _this.commonClass.hideForMobile );
				$child.css( "display", "none" );

				_this.activateSubsection();

			} else {

				_this.deactivateSubsection();
				$child.addClass( _this.commonClass.hideForMobile );

			}

		};

		/**
		 * collapse an element
		 *
		 * @param  {Function} callback   | code after slide up animation
		 */
		_this.mobile.collapseSubsection = function( $target, callback ) {

			$target.slideUp( _this.slideAnimationDuration, callback );

		};

		/**
		 * expand an element
		 *
		 * @param  {Function} callback   | code after slide down animation
		 */
		_this.mobile.expandSubsection = function( $target, callback ) {

			$target.slideDown( _this.slideAnimationDuration, callback );

		};

		/**
		 * append subsection content to below ".info-subsection__title"
		 * @param  {String} subsectionId    subsection id of current active subsection
		 * @param  {String} html            content html
		 */
		_this.mobile.appendSubsectionContent = function( subsectionId, html ) {

			var $child,
				template,
				subsectionChildHtml;

			template = Handlebars.compile( _this.$subsectionChildTempl.html() );
			subsectionChildHtml = template( {
				content: html
			} );

			if ( subsectionId ) {

				// append subsectionChild
				_this.$menuColumn
					.find( ".info-subsection__link[data-subsection = '" + subsectionId + "' ]" )
					.closest( ".info-subsection__item" )
					.append( subsectionChildHtml );

				// update $child to activeObj
				$child = _this.activeObj.$item.find( ".info-subsection__child" );
				_this.activeObj.$child = $child;

				_this.activateSubsection( function() {

					LC.pubsub.trigger( "finishExpand" + _this.namespace, _this.activeObj.$item );

				} );

			}

			LC.pubsub.trigger( "finishAppendContent"  + _this.namespace, _this.activeObj.$item );

		};

		ex.subsectionEvents = function() {

			_this.$subsectionLink
				.off( _this.namespace )
				.checkmove()
				.on( _this.clickEvent, function( e ) {

					e.preventDefault();

					if ( !$( this ).data( "touchmoved" ) ) {

						_this.clickSubsection( $( this ) );

					}

				});

		};

		ex.events = function() {

			_this.$subsectionLink
				.off( _this.namespace )
				.checkmove()
				.on( "touchend" + _this.namespace + " " + "click" + _this.namespace, function( e ) {

					e.preventDefault();

					if ( !$( this ).data( "touchmoved" ) ) {

						LC.warn( "the info content is not yet ready." );

					}

				});

		};

		ex.subscribe = function() {

			LC.pubsub.on( "contentReady.infoPage", function() {

				ex.subsectionEvents();

			} );

			LC.pubsub.on( "change.section.infoPage", function( e, targetSectionItem, sectionId ) {

				// As section changes, the default subsection and it's child has to be update
				_this.refreshDefaultSubsection( $( targetSectionItem ), sectionId );

			} );

			LC.pubsub.on( "updateSubsectionChild.infoPage", function( e, subsectionId, html) {

				// after retrieve the desired info content, update active subsection child
				_this.mobile.appendSubsectionContent( subsectionId, html );

			} );

		};

		return exports;

	});

}( window.LC = window.LC || {}, jQuery ));

/**
 *
 * [ module ]
 * infoPage -> content
 *
 */

( function( LC, $ ) {

	"use strict";

	new lcmodule2( "infoPage.content", function( exports, _this ) {

		var ex = exports;

		// set up some objects for grouping functions
		ex.track = {};

		ex.setup = function() {

			_this.namespace = ".content.infoPage";

			_this.$detailColumn = $( ".info-help__detail" );
			_this.$contentLink = $( ".info-content__link" );

		};

		ex.init = function() {

			// initialisation code
			_this.commonClass = LC.infoPage.general.commonClass;
			_this.slideAnimationDuration = LC.infoPage.general.slideAnimationDuration;

			ex.initActiveSubsectionObj();
			if ( Foundation.MediaQuery.is( "mb only" ) ) {
				LC.infoPage.general.scrollToViewport( _this.activeObj.$item.eq(0) );
			} else {
				LC.infoPage.general.scrollToViewport( _this.activeObj.$item.eq(1) );
			}

		};

		/**
		 * init the activeObj by getting
		 * 	- active ".info-content__item"
		 * 	- active ".info-content__desc"
		 * 	- active ".info-content__bullet"
		 * 	- active ".info-bullet__plus"
		 * 	- active section id
		 * 	- active subsection id
		 * 	- active content id
		 */
		ex.initActiveSubsectionObj = function() {

			var $activeContentItem = $( ".info-content__item.is-active" ),
				$activeContentDesc = $activeContentItem.find( ".info-content__desc" ),
				$activeContentBullet = $activeContentItem.find( ".info-content__bullet" ),
				$activeContentBulletPlus = $activeContentBullet.find( ".info-bullet__plus" ),
				sectionId = $activeContentItem.find( ".info-content__link" ).data( "section" ),
				subsectionId = $activeContentItem.find( ".info-content__link" ).data( "subsection" ),
				contentId = $activeContentItem.find( ".info-content__link" ).data( "content" );

			_this.activeObj = {

				$item:          $activeContentItem,
				$desc:          $activeContentDesc,
				$bullet:        $activeContentBullet,
				$bulletPlus:    $activeContentBulletPlus,
				sectionId:      sectionId,
				subsectionId:   subsectionId,
				contentId:      contentId

			};

		};

		/**
		 * get data about the user clicked section item link
		 *
		 * @param  {jQuery} $target     | jQuery object to section link
		 * @return {object} targetObj   | object contain following info
		 *                          	   - jQuery object of the clicked content item
		 *                          	   - jQuery object of the clicked content child
		 *                          	   - jQuery object of the clicked content bullet
		 *                          	   - jQuery object of the clicked content plus icon in bullet
		 *                          	   - content id
		 *                          	   - is clicked content is in active state
		 */
		_this.getTargetContentDetail = function( $targetItem ) {

			var $targetDesc = $targetItem.find( ".info-content__description" ),
				$targetBullet = $targetItem.find( ".info-content__bullet" ),
				$targetBulletPlus = $targetBullet.find( ".info-bullet__plus" ),
				sectionId = $targetItem.find( ".info-content__link" ).data( "section" ),
				subsectionId = $targetItem.find( ".info-content__link" ).data( "subsection" ),
				contentId = $targetItem.find( ".info-content__link" ).data( "content" ),
				isActive = $targetItem.hasClass( _this.commonClass.active ),
				targetObj;

			targetObj = {
				$item: $targetItem,
				$desc: $targetDesc,
				$bullet: $targetBullet,
				$bulletPlus: $targetBulletPlus,
				sectionId: sectionId,
				subsectionId: subsectionId,
				contentId: contentId,
				isActive: isActive
			};

			return targetObj;

		};

		/**
		 * handling content link clicking by 2 different cases
		 * 	- when clicking active content link
		 * 		- "_this.deactivateContent()"
		 * 		- remove "activeClass"
		 * 	- else
		 * 		- call "_this.changeContent()"
		 *
		 * @param  {jQuery}     $target jQuery object to subsection link
		 */
		_this.clickContent = _.throttle( function( $target ) {

			// finding content item by searching "info-content__link" by section id, subsection id, content id,
			// because the page has 2 set of content in menu and detail column respectively.

			var sectionId = $target.data( "section" ),
				subsectionId = $target.data( "subsection" ),
				contentId = $target.data( "content" ),
				$targetContentItem = $(
					".info-content__link[ data-section='" + sectionId + "' ]" +
					"[ data-subsection='" + subsectionId + "' ]" +
					"[ data-content='" + contentId + "' ]" )
					.closest( ".info-content__item" ),
				targetObj = _this.getTargetContentDetail( $targetContentItem );

			if ( targetObj.isActive ) {

				_this.deactivateContent();

				_this.activeObj.$item.removeClass( _this.commonClass.active );

				LC.pubsub.trigger( "setHistory" + _this.namespace, [ _this.activeObj.sectionId, _this.activeObj.subsectionId ] );

			} else {

				_this.changeContent( targetObj );

			}

		}, 500, {
			leading: true,
			trailing: false
		} );

		/**
		 * handling clicking non active content link
		 * 	1. deactivate / collapse exising subsection
		 * 	2. activate / expand clicked subsection
		 *
		 * @param  {object} targetObj | include data:
		 *     - $item
		 *     - $child
		 *     - $bullet
		 *     - $bulletPlus
		 *     - sectionId
		 *     - isActive
		 */
		_this.changeContent = function( targetObj ) {

			var targetSectionId = targetObj.sectionId,
				targetSubsectionId = targetObj.subsectionId,
				targetContentId = targetObj.contentId;

			_this.deactivateContent();
			_this.activeObj.$item.removeClass( _this.commonClass.active );

			// cached active jquery object
			_this.activeObj = targetObj;

			_this.activateContent( function() {

				LC.pubsub.trigger( "finishExpand" + _this.namespace, _this.activeObj.$item );

			} );

			LC.pubsub.trigger( "setHistory" + _this.namespace,
				[ targetSectionId, targetSubsectionId, targetContentId ] );

		};

		/**
		 * action for deactivate current content
		 *  1. call "_this.collapseContent()" for collapse the clicked content description
		 *  2. remove the "rotateClass" for content bullet ( in mobile view )
		 *  3. remove the "fadeOutClass" for content bullet plus icon
		 */
		_this.deactivateContent = function() {

			_this.collapseContent();

			_this.activeObj.$bullet.removeClass( _this.commonClass.rotate );
			_this.activeObj.$bulletPlus.removeClass( _this.commonClass.fadeOut );

		};

		/**
		 * action for activate clicked content
		 *  1. call "_this.expandContent()" for expand the clicked content description
		 *  2. add "activeClass" to the clicked content item
		 *  3. add "rotateClass" to the clicked content bullet
		 *  4. add "fadeOutClass" to the clicked content bullet plus icon
		 *
		 * @param  {function} callback    | function that need to run after slide down animation
		 */
		_this.activateContent = function( callback ) {

			var $item = _this.activeObj.$item,
				$desc = _this.activeObj.$desc,
				$bullet = _this.activeObj.$bullet,
				$bulletPlus = _this.activeObj.$bulletPlus;

			_this.expandContent( $desc, callback );

			$item.addClass( _this.commonClass.active );
			$bullet.addClass( _this.commonClass.rotate );
			$bulletPlus.addClass( _this.commonClass.fadeOut );

		};

		/**
		 * collapse an element
		 *
		 * @param  {Function} callback   | optional: code after slide up animation
		 */
		_this.collapseContent = function( callback ) {

			_this.activeObj.$desc.slideUp( _this.slideAnimationDuration, callback );

		};

		/**
		 * expand an element
		 *
		 * @param  {jQuery} $target   | jQuery object of the element for expand
		 */
		_this.expandContent = function( $target, callback ) {

			$target.slideDown( _this.slideAnimationDuration, callback );

		};

		/**
		 * append content to ".info-detail" column
		 * @param  {[type]} html        | html of desired content
		 */
		_this.appendContent = function( html ) {

			_this.$detailColumn.html( html );

			ex.bindContentEvent();

		};

		/**
		 * bind clicking event for content link
		 */
		ex.bindContentEvent = function() {

			_this.$contentLink = $( ".info-content__link" );

			_this.$contentLink
				.off( _this.namespace )
				.checkmove()
				.on( "touchend" + _this.namespace + " " + "click" + _this.namespace, function( e ) {

					e.preventDefault();

					if ( !$( this ).data( "touchmoved" ) ) {

						_this.clickContent( $( this ) );

					}

				});

		};

		ex.events = function() {

			ex.bindContentEvent();

		};

		ex.subscribe = function() {

			LC.pubsub.on( "updateContent.infoPage", function( e, html ) {

				// after retrieve the desired info content, update active section direct content
				_this.appendContent( html );

			} );

			LC.pubsub.on( "finishAppendContent.subsection.infoPage " +
				"finishAppendContent.section.infoPage", function() {

				ex.bindContentEvent();

			});

		};

		return exports;

	});

}( window.LC = window.LC || {}, jQuery ));

 //# sourceURL=infoHelp.js
